import React, {useEffect} from "react";
import InfoCircle from "@mui/icons-material/InfoRounded";
import {Form, Table} from 'react-bootstrap';
import {Dropdown} from '../../../../../shared/ui/Dropdown';

const ModbusRTUMeterTable = (props) => {

  return (
    <Table>
      <tbody>
      <tr>
        <th className="text-start"><span>Typ</span></th>
        <td className="text-end"><span>{props.device.deviceType}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>Name</span></th>
        <td className="text-end"><span>{props.device.name}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>Modbus ID</span></th>
        <td className="text-end"><span>{props.device.modbusId}</span></td>
      </tr>
      <tr>
        {props.device.usbDevice ? <th className="text-start"><span>USB Device</span></th> :
          <th className="text-start"><span>IP Address</span></th>}
        <td className="text-end"><span>{props.device.usbDevice || props.device.ip}</span></td>
      </tr>
      </tbody>
    </Table>
  )
}

const ModbusRTUMeterForm = (props) => {
  const [connectionType, setConnectionType] = React.useState(props.device.usbDevice ? "USB" : "IP");

  // verify all fields are filled before saving
  useEffect(() => {
    if (props.device.name && (props.device.usbDevice || props.device.ip) && props.device.modbusId) {
      props.setSaveDisabled(false);
    } else {
      props.setSaveDisabled(true);
    }
  }, [props.device, props.device.usbDevice, props.device.ip]);

  return (
    <Form>
      <Form.Group>
        <Form.Label>Typ</Form.Label>
        <Dropdown
          name="deviceType"
          options={[
            {value: 'PRO380-Mod', label: 'Pro380 Mod'},
            {value: 'PRO380-Mod-ZEV', label: 'Pro380 Mod ZEV'},
            {value: 'WAGO2857-0570', label: 'WAGO2857-0570'},
          ]}
          value={props.device.deviceType}
          onChange={props.handleChange}
          block
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={props.device.name}
          onChange={props.handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Modbus ID</Form.Label>
        <Form.Control
          type="integer"
          name="modbusId"
          value={parseInt(props.device.modbusId)}
          onChange={props.handleChange}/>
      </Form.Group>
      <Form.Label>Verbindung (IP/USB) <a
        href="https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#error%2C-usbDevice"
        target="_blank" rel="noopener noreferrer"><InfoCircle size={14}/></a></Form.Label>
      <Form.Group>
        <Form.Check
          type="switch"
          id="connectionTypeSwitch"
          label={connectionType === "USB" ? "USB Device" : "IP Address"}
          checked={connectionType === "USB"}
          onChange={(e) => {
            const isUSB = e.target.checked;
            setConnectionType(isUSB ? "USB" : "IP");

            props.device.ip = isUSB ? null : ""
            props.device.usbDevice = isUSB ? "" : null
          }}
        />
      </Form.Group>
      {connectionType === "USB" ? (
        <Form.Group>
          <Form.Control
            type="text"
            name="usbDevice"
            value={props.device.usbDevice}
            onChange={props.handleChange}
          />
        </Form.Group>
      ) : (
        <Form.Group>
          <Form.Control
            type="text"
            name="ip"
            value={props.device.ip}
            onChange={props.handleChange}
          />
        </Form.Group>
      )}
    </Form>
  )
}

export {ModbusRTUMeterTable, ModbusRTUMeterForm};